import { useState, useEffect } from "react";
import { ReactPalette } from "gojs-react";
import go from "gojs";
// import { getSvgDimensions } from "./svgUtils";
import { getFileList } from "@/services/common";
import element from "./newElements.json";
import boiler from "./elementsData/boiler.json";
import comments from "./elementsData/comments.json";
import container from "./elementsData/container.json";
import equipment from "./elementsData/equipment.json";
import heatExchanger from "./elementsData/heatExchanger.json";
import others from "./elementsData/others.json";
import products from "./elementsData/products.json";
import pump from "./elementsData/pump.json";
import reactor from "./elementsData/reactor.json";
import separator from "./elementsData/separator.json";
import tank from "./elementsData/tank.json";
import tower from "./elementsData/tower.json";
import Flash2 from "./elementsData/Flash2.json";
import MultiStreamExchanger from "./elementsData/MultiStreamExchanger.json";
import Mixer from "./elementsData/Mixer.json";

const elementsDatas = 
{
  boiler:boiler,
  comments:comments,
  container:container,
  equipment:equipment,
  ShellAndTubeExchanger:heatExchanger,
  others:others,
  products:products,
  pump:pump,
  reactor:reactor,
  Splitter:separator,
  tank:tank,
  DistilStrict:tower,
  Flash2:Flash2,
  Mixer:Mixer,
  MultiStreamExchanger:MultiStreamExchanger,
};

const Component = (props: any) => {
  const { diagrams } = props;
  const [source, setSource] = useState<any>(null);
  const [type,setType] = useState("reactor");
  // 定义固定的缩略图尺寸（根据需要调整）
  // const THUMBNAIL_SIZE = new go.Size(80, 80); // 固定80x80像素

  const getThumbnailSize = (origWidth:number, origHeight:number) => {
    // 处理无效尺寸
    if (origWidth <= 0 || origHeight <= 0) {
      return { width: 80, height: 80 };
    }
    
    if (origHeight > origWidth) {
      // 纵向：高度固定80，宽度自适应
      const ratio = 80 / origHeight;
      return { width: origWidth * ratio, height: 80 };
    } else if (origWidth > origHeight) {
      // 横向：宽度固定100，高度自适应
      const ratio = 100 / origWidth;
      return { width: 100, height: origHeight * ratio };
    } else {
      // 正方形：固定80×80
      return { width: 80, height: 80 };
    }
  };

  const getProxyUrl = (originalUrl) => 
  {
    // 原始SVG域名
    const svgBaseUrl = "https://devindata-oss.oss-cn-beijing.aliyuncs.com";
    // 用代理标识路径替换原始域名（例如：/proxy-svg + 资源路径）
    return `/proxy-svg${originalUrl.replace(svgBaseUrl, '')}`;
  };

  // 获取SVG尺寸的核心函数
  const getSvgDimensions = async (svgUrl) => 
  {
    svgUrl = `${svgUrl}.svg`
    // 1. 判断是否为 SVG 文件（支持带查询参数）
    const isSvg = (url) => {
      // 提取路径部分，忽略查询参数和哈希
      const cleanUrl = url.split('?')[0].split('#')[0];
      return cleanUrl.toLowerCase().endsWith('.svg');
    };

    if (!svgUrl || !isSvg(svgUrl)) {
      console.warn(`跳过非SVG文件或无效URL: ${svgUrl}`);
      return { width: 80, height: 80 }; // 返回默认尺寸
    }

    try {
      // 2. 决定请求 URL（是否需要代理）
      let requestUrl = svgUrl;
      try {
        const urlObj = new URL(svgUrl, window.location.origin);
        // 如果是绝对路径且非同源，则使用代理（需根据您的 getProxyUrl 实现调整）
        if (urlObj.origin !== window.location.origin && urlObj.protocol.startsWith('http')) {
          requestUrl = getProxyUrl(svgUrl); // 假设 getProxyUrl 已定义
        }
      } catch {
        // 相对路径，直接使用原路径
        requestUrl = svgUrl;
      }

      // 3. 请求 SVG 内容
      const response = await fetch(requestUrl);
      if (!response.ok) {
        throw new Error(`请求失败: ${response.status}`);
      }

      const svgText = await response.text();
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgText, "image/svg+xml");
      const svgElement = svgDoc.querySelector("svg");
      if (!svgElement) {
        throw new Error("无法找到SVG根元素");
      }

      // 4. 提取宽高
      let width = svgElement.getAttribute("width");
      let height = svgElement.getAttribute("height");

      if (!width || !height) {
        const viewBox = svgElement.getAttribute("viewBox");
        if (viewBox) {
          const [, , vbWidth, vbHeight] = viewBox.split(/\s+/).map(Number);
          width = width || vbWidth.toString();
          height = height || vbHeight.toString();
        }
      }

      // 转换为数字（去除单位）
      return {
        width: Number(width?.replace(/[^\d.]/g, '') || 0),
        height: Number(height?.replace(/[^\d.]/g, '') || 0)
      };

    } catch (error) {
      console.error(`获取${svgUrl}尺寸失败:`, error);
      return { width: 0, height: 0 }; // 失败时返回 0，或根据业务返回默认值
    }
  };

  useEffect(() => 
  {
    const loadComponentSizes = async () => {
      if (!diagrams) return;

      let newSources = {};
      for (let key in elementsDatas)
      {
        let elementsData = elementsDatas[key];

        // 遍历元件列表，为每个元件添加尺寸信息
        const nodesWithSize = await Promise.all(
          elementsData?.map(async (component, index) => {
            // 获取 SVG 原始尺寸
            // const { width, height } = await getSvgDimensions(component.icon);
            const { width: origWidth, height: origHeight } = await getSvgDimensions(component.icon);
            const { width: thumbWidth, height: thumbHeight } = getThumbnailSize(origWidth, origHeight);

            return {
              // key: component.name,
              type:key,
              text: component.name,
              icon: `${component.icon}.svg`, // 绑定图片地址
              // size: `${width*3} ${height*3}`, // 原始尺寸
              // thumbnailSize: `${THUMBNAIL_SIZE.width} ${THUMBNAIL_SIZE.height}`, // 固定缩略图尺寸
              size: `${origWidth*3} ${origHeight*3}`,
              thumbnailSize: `${thumbWidth} ${thumbHeight}`,
              // textColor: "#5F5F5F",
              // fontSize: "48pt Segoe UI,sans-serif",
              nodeName: component.nodeName,
              elementName:component.name,
              params:component.params,
              physical_method:undefined,
              phase:undefined,
              mode:undefined,
              point:component.point?component.point:[0,0],
              textBackground:component.textBackground?component.textBackground:"rgba(0,0,0,0)",
              description:"",
            };
          })
        );
        console.log(`nodesWithSize:${key}:`,nodesWithSize);
        newSources[key] = nodesWithSize;
      };
      setSource(newSources);
    };
    loadComponentSizes();
  }, [diagrams,elementsDatas]); // 依赖 diagrams 初始化完成（确保模板可用）


  const initPalette = () => 
  {
    // 定义 $ 为 go.GraphObject.make 的简写，用于创建 GoJS 对象
    const $ = go.GraphObject.make;
    // 创建一个新的 GoJS 面板（Palette）实例，用于显示可拖拽的元件库
    const palette = new go.Palette();
    // 设置面板的节点模板，定义每个元件在面板中的显示方式
    palette.nodeTemplate = $(
      // 创建一个“点状”（Spot）类型的节点，图片居中，文本可放置在下方
      go.Node,
      "Spot",                         // 节点类型为 Spot，允许将子部件定位在九宫格点上
      
      // 第一组节点属性：基础属性
      {
        zOrder: 1,                    // 绘制顺序（数值越大越靠上）
        locationSpot: go.Spot.Center, // 节点位置基于其中心点
      },
      
      // 第二组节点属性：尺寸调整限制
      {
        resizable: false,             // 禁止在面板中调整节点大小（保持缩略图固定尺寸）
      },
      
      // 第三组节点属性：选择与高亮
      {
        selectable: true,             // 允许选中节点
        selectionObjectName: "SHAPE", // 选中时高亮名称为 "SHAPE" 的元素（即图片）
      },
      
      // 第四组节点属性：旋转限制
      {
        rotatable: false,             // 禁止旋转节点（保持图片方向固定）
      },
      
      // 创建图片部件，用于显示 SVG 图标
      $(
        go.Picture,                   // 图片类型
        {
          name: "SHAPE",              // 命名为 "SHAPE"，用于选中高亮
        },
        // 双向绑定：图片的 source 属性绑定到节点数据的 "icon" 字段
        new go.Binding("source", "icon").makeTwoWay(),
        // 关键绑定：图片的 desiredSize（期望尺寸）绑定到数据的 "thumbnailSize" 字段，
        // 使用 go.Size.parse 函数将字符串（如 "80 80"）解析为 go.Size 对象
        new go.Binding("desiredSize", "thumbnailSize", go.Size.parse)
      ),
      
      // 创建文本部件，用于显示元件名称
      $(
        go.TextBlock,                 // 文本块类型
        {
          editable: true,            // 禁止在面板中编辑文本
          font: "14pt Segoe UI,sans-serif", // 字体样式
          stroke: "#000",             // 默认文字颜色（黑色）
          // 对齐方式：相对于节点位置水平居中（0.5），垂直方向在节点下方（1.2 倍节点高度处）
          alignment: new go.Spot(0.5, 1.2),
        },
        // 双向绑定：文本内容绑定到节点数据的 "text" 字段
        new go.Binding("text", "text").makeTwoWay(),
        // 双向绑定：文字颜色绑定到节点数据的 "textColor" 字段
        new go.Binding("stroke", "textColor").makeTwoWay(),
        new go.Binding("alignment", "point", function (x) {
          return new go.Spot(x[0], x[1]);
        }),
      )
    );

    // 禁用动画管理器，去除所有过渡动画
    palette.animationManager.isEnabled = false;
    
    palette.layout = $(go.GridLayout, 
    { 
      wrappingColumn: Infinity,   // 强制所有节点放在同一行
      wrappingWidth: Infinity,    // 不限制布局宽度
      spacing: new go.Size(50,20) // 节点之间的水平间距
    });

    // 启用水平滚动，禁止垂直滚动
    palette.allowHorizontalScroll = true;
    palette.allowVerticalScroll = false;

    palette.contentAlignment = new go.Spot(0,1);//水平靠左，垂直居中

    // 返回配置完成的面板实例，供 ReactPalette 使用
    return palette;
  };

  return (
    <div style={{height:"180px",margin:"0px",borderTop:"1px solid #BBB",backgroundColor:"#eee",}}>
      <div style={{display:"flex",flexDirection:"row",height:"15%",backgroundColor: "#eee",borderBottom:"1px solid #BBB"}}>
        {
          element.filter(item=>item.typeID!=="group"&&item.typeID!=="link").map(item => 
          (
            <button 
              key={item.typeID}
              style={{width:"100px",height:"100%",borderRadius:"0",borderWidth:"0px 1px 0px 0px",borderStyle:"solid",borderColor:"#BBB",fontSize:14,backgroundColor:type===item.typeID?"#BBB":"#eee",color:type===item.typeID?"#000":"#5F5F5F"}}
              onClick={()=>{setType(item.typeID);}}
            >
              {item.typeName}
            </button>
          ))
        }
      </div>
      <ReactPalette
        initPalette={initPalette}
        divClassName="palette-component"
        style={{
          backgroundColor: "#eee",
          height:"calc(80% - 0px)",
          // marginTop:20
        }}
        nodeDataArray={source?.[type]||[]}
      />
    </div>
  );
};

export default Component;
